"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _loadingOverlay = _interopRequireDefault(require("./styles/loadingOverlay.styles"));

var useStyles = (0, _styles.createUseStyles)(_loadingOverlay.default, 'LoadingOverlay');

var _ref2 = /*#__PURE__*/_react.default.createElement(_Loader.default, {
  size: "massive"
});

function LoadingOverlay(_ref) {
  var classesProp = _ref.classes;
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, _ref2);
}

var _default = /*#__PURE__*/_react.default.memo(LoadingOverlay);

exports.default = _default;